import BaseServices from "./BaseServices";

const CusStockphotoServices = {
    CreateManyStockPhoto: async (model) => {
        return BaseServices.Post(`/api/CUSStockPhoto/create-many-stock-photo`, model);
    }
};

export default CusStockphotoServices;
